<template>
  <section v-if="error">
  <br/>
  <p class="error">{{ error }}</p>
  </section>
  <section v-if="validation">
  <br/>
  <p class="error">{{ validation }}</p>
  </section>

  <section class="page-container grid-container" v-if="!error && loaded">
    <div class="grid-container wizard">
      
        <section>    
        <div class="grid-x grid-margin-x">
            <div class="cell small-12">
                <a @click="router.back()">← Back</a>
            </div>
        </div>
        </section>
        <section v-if="isSubmitting">
            <LoadingAnimation :informationMessage="progressMessage" />
        </section>
        <section :style="{ display: isSubmitting ? 'none' : '' }">
            <div class="grid-x grid-margin-x">
                <div v-if="apiAgreement.taskStatus !== 'SuccessfullyCompleted'" class="cell small-12">
                    <h1 class="text-2xl font-bold">{{apiAgreement.taskName}}</h1>
                    <p>During your pre-engagement questionnaire it was identified that you have a requirement for {{toLower(apiAgreement.taskName)}} to take place.</p><p>Please provide our team with further information on your requirement, so it can be reviewed and assessed.</p>
                    <label>Customers Requirements:</label>
                    <textarea
                        style="height: 220px;"
                        v-model="customerRequirementDescription"
                        placeholder="Provide details about your requirement..."
                        :readonly="!isInDrafting"
                    />
                    <div v-if="userType == 'Administrator'">
                        <label v-if="isWithNegotiator || isWithClient">Feedback from Systems Manager</label>
                        <textarea
                            v-if="isWithNegotiator || isWithClient"
                            style="height: 220px;"
                            v-model="processSummaryDescription"
                            placeholder="Provide details about your requirement..."
                            :readonly="isWithNegotiator || isWithClient"
                        />
                    </div>
                    <br/>
                    <span v-if="isInDrafting">
                        <p><label><Strong>Supporting Documents</Strong></label></p>
                        <p>Please provide our team with any supporting documents that will assist them in assessing your requirement.</p>
                        <FileUploader :multiple="true" :folderName="clientId" ref="fileUploadReference" />
                        <br/>
                    </span>


                    <div v-if="apiAgreement.supportingDocuments && apiAgreement.supportingDocuments.length">
                        <p><strong>Uploaded Supporting Documents</strong></p>
                        <ul>
                            <li v-for="(doc, idx) in apiAgreement.supportingDocuments" :key="idx">
                                <a :href="doc.blobUri" target="_blank" rel="noopener">
                                    {{ doc.fileName }}
                                </a>
                            </li>
                        </ul>
                    </div>


                    <!-- If block to conditionally display buttons if with reviewer-->
                    <div v-if="userType == 'Administrator'">
                        <span v-if="isWithNegotiator || isWithClient">
                            <button
                                class="btn btn-secondary"
                                @click="submitAmendments"
                            >
                                Submit Amendments
                            </button>

                            <button
                            class="btn btn-primary"
                            @click="submitConfirmedAgreement"
                            v-if="isAccepted"
                            >
                                Confirm Agreement
                            </button>
                        </span>
                    </div>

                        <button
                        class="btn btn-secondary"
                        @click="submitForm"
                        v-if="isInDrafting"
                        >
                        Submit Requirement
                        </button>

                </div>
                <div v-else class="cell small-12">
                    <h1 class="text-2xl font-bold">Requirement Agreement Complete</h1>
                    <p>During your pre-engagement questionnaire it was identified that you have a requirement for {{toLower(apiAgreement.taskName)}} to take place.</p>
                    <p>Your requirement has been submitted and reviewed by our team.</p>
                    <textarea
                        style="height: 220px;"
                        v-model="customerRequirementDescription"
                        placeholder="Provide details about your requirement..."
                        :readonly="true"
                    />
                    <span v-if="apiAgreement.processSummary != null && apiAgreement.processSummary !== ''">

                        <p>The following process has been agreed upon by all parties regarding your requirement.</p>
                        <textarea
                            style="height: 220px;"
                            v-model="apiAgreement.processSummary"
                            placeholder="Process Summary..."
                            :readonly="true"
                        />  
                    </span>
                    <br/>
                    <button class="btn btn-secondary" @click="router.back()">Return to Requirements</button>
                </div>
            </div>
        </section>
    </div>
  </section>
</template>

<script setup>
import { onMounted, ref, computed } from 'vue'
import { useRouter } from 'vue-router'
import { getRequirementAgreementTask, putRequirementAgreementTask } from '@/services/implementationmanagement.api';
import { postAgreementRequirement } from '@/services/powerautomate.func';
import { toLower } from '@/helpers/strings';
import FileUploader from '@/components/controls/FileUploader.vue'
import { useIdentityStore } from '@/stores/identity';
import LoadingAnimation from '@/components/LoadingAnimation.vue';


const identityStore = useIdentityStore();
const router  = useRouter()
const loaded = ref(false);
const taskId = router.currentRoute.value.params.agreementId;
const error = ref(null);
const validation = ref(null);
const powerAutomateAgreement = ref(null);
const apiAgreement = ref(null);
const fileUploadReference = ref(null);
const clientId = ref(null);
const userType = ref(null);


/*
Show a feedback message box in here - WithClient


Drafting - With Customer show box 
WithInternalReviewer - 
WithClient - Show box read only and show the feedback message and allow them to agree.


*/


const errorString = 'An error has occurred. Please contact your Qtac account manager.';

const customerRequirementDescription = ref('');
const processSummaryDescription = ref('');

onMounted(async () => {

    try {

        clientId.value = identityStore.selectedClientId;
        userType.value = identityStore.type;

        var agreementResponse = await getRequirementAgreementTask(taskId);

        if(agreementResponse.status !== 200 || agreementResponse.data === null || agreementResponse.data === undefined) {
            error.value = errorString;
            return null;
        }

        powerAutomateAgreement.value = agreementResponse.data;
        apiAgreement.value = JSON.parse(JSON.stringify(agreementResponse.data));
        customerRequirementDescription.value = apiAgreement.value.clientRequirementDescription || '';
        processSummaryDescription.value = apiAgreement.value.processSummary || '';

    } catch (err) {
        error.value = errorString;
        console.error(err);
    }




loaded.value = true;
})


/* Progress Variables */
const isSubmitting = ref(false);
const progressMessage = ref('');

const isInDrafting = computed(() => {
    return powerAutomateAgreement.value && powerAutomateAgreement.value.agreementStatus === 'Drafting';
});

const isWithReviewer = computed(() => {
    return powerAutomateAgreement.value && powerAutomateAgreement.value.agreementStatus === 'WithInternalReviewer' 
    && powerAutomateAgreement.value.agreementOutcome === 'Open';
});

const isWithNegotiator = computed(() => {
    return powerAutomateAgreement.value && powerAutomateAgreement.value.agreementStatus === 'WithInternalNegotiator';
});


const isWithClient = computed(() => {
    return powerAutomateAgreement.value && powerAutomateAgreement.value.agreementOutcome === 'WithClient';
});

const isAccepted = computed(() => {
    return powerAutomateAgreement.value && powerAutomateAgreement.value.agreementOutcome === 'Accepted';
});

const submitForm = async () => {
    validation.value = null;
    isSubmitting.value = true;

    if (await isFormValid()) {
        try {

            progressMessage.value = 'Uploading your documents...';

            let uploadedFiles = [];
            if (fileUploadReference.value) {
                const files = await fileUploadReference.value.uploadToBlobStorage();

                uploadedFiles = files.map(file => ({
                    fileName: file.data.filename,
                    blobUri: file.data.url,
                    taskId: taskId
                }));
            }

            progressMessage.value = 'Upload Complete. Submitting your requirement...';

            powerAutomateAgreement.value.clientRequirementDescription = customerRequirementDescription.value;
            powerAutomateAgreement.value.clientApproval = {};
            powerAutomateAgreement.value.internalReview = {};


            let payload = {
                clientId: clientId.value,
                companyname: "test",
                mode: "Implementation",
                requirementAgreementTask: powerAutomateAgreement.value,
                supportingDocuments: uploadedFiles
            }

            const paResponse = await postAgreementRequirement(payload);

            if (paResponse.status !== 200 && paResponse.status !== 202) {
                error.value('Failed to submit requirement');
                return;
            }
            


            apiAgreement.value.clientRequirementDescription = customerRequirementDescription.value;
            apiAgreement.value.agreementStatus = "WithInternalReviewer";
            apiAgreement.value.taskStatus = "InProgress";

            
            const apiReponse = await putRequirementAgreementTask(taskId, apiAgreement.value);

            if (apiReponse.status !== 200) {
                error.value = 'Failed to update requirement agreement task';
                return;
            }

            isSubmitting.value = false;

            router.back()

        } catch (err) {
            isSubmitting.value = false;
            validation.value = errorString;
            console.error(err);
        }
    }
    else {
        isSubmitting.value = false;
    }
};


// submit amendments when with negotiator
const submitAmendments = async () => {
    console.log('Submit Amendments clicked');
};


// submit confirmed agreement when accepted
const submitConfirmedAgreement = async () => {

    apiAgreement.value.agreementStatus = "Closed";
    apiAgreement.value.taskStatus = "SuccessfullyCompleted";
    const apiReponse = await putRequirementAgreementTask(taskId, apiAgreement.value);

    if (apiReponse.status !== 200) {
        error.value = 'Failed to update requirement agreement task';
        return;
    }

    router.back();  
};


const isFormValid = async () => {
    validation.value = null;

    if (!customerRequirementDescription.value.trim()) {
        validation.value = 'Please provide details about your requirement.';
        return false;
    }

    return true;
};



</script>

